import React, { Component, useState, useEffect } from 'react';
import { array, arrayOf, bool, func, shape, string, oneOf } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_PENDING_APPROVAL, LISTING_STATE_CLOSED, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import moment from 'moment';
import { formatMoney } from '../../util/currency';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import {
  Page,
  NamedLink,
  NamedRedirect,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  BookingPanel,
  Button,
  Modal,
} from '../../components';
import { TopbarContainer, NotFoundPage } from '../../containers';
import { post } from '../../util/api';
import {
  sendEnquiry,
  fetchTransactionLineItems,
  setInitialValues,
  subscribe,
  requestSubscribe,
} from './ListingPage.duck';
import SectionImages from './SectionImages';
import SectionAvatar from './SectionAvatar';
import SectionHeading from './SectionHeading';
import SectionDescriptionMaybe from './SectionDescriptionMaybe';
import SectionPracticalInfo from './SectionPracticalInfo';
import SectionFeaturesMaybe from './SectionFeaturesMaybe';
import SectionReviews from './SectionReviews';
import SectionHostMaybe from './SectionHostMaybe';
import SectionRulesMaybe from './SectionRulesMaybe';
import SectionMapMaybe from './SectionMapMaybe';
import { SingleDatePicker } from 'react-dates';
import css from './ListingPage.module.css';
import CircularProgress from '@mui/material/CircularProgress';
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID, Money } = sdkTypes;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

const categoryLabel = (categories, key) => {
  const cat = categories.find(c => c.key === key);
  return cat ? cat.label : key;
};

export class ListingPageComponent extends Component {
  constructor(props) {
    super(props);
    const { enquiryModalOpenForListingId, params } = props;
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      enquiryModalOpen: enquiryModalOpenForListingId === params.id,
      focused: false,
      loadingSpinner: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onContactUser = this.onContactUser.bind(this);
    this.onSubmitEnquiry = this.onSubmitEnquiry.bind(this);
    this.onSubmitSubscribe = this.onSubmitSubscribe.bind(this);
    this.onSubmitRequestSubscribe = this.onSubmitRequestSubscribe.bind(this);
    // this.setDate = this.setDate.bind(this);
  }

  handleSubmit(values) {
    const {
      history,
      getListing,
      params,
      callSetInitialValues,
      onInitializeCardPaymentData,
    } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);

    const { bookingDates, ...bookingData } = values;

    const initialValues = {
      listing,
      bookingData,
      bookingDates: {
        bookingStart: bookingDates.startDate,
        bookingEnd: bookingDates.endDate,
        startTime: bookingDates.startTime,
        endTime: bookingDates.endTime,
      },
      confirmPaymentError: null,
    };

    const saveToSessionStorage = !this.props.currentUser;

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        { id: listing.id.uuid, slug: createSlug(listing.attributes.title) },
        {}
      )
    );
  }

  onContactUser() {
    const { currentUser, history, callSetInitialValues, params, location } = this.props;

    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };

      // We need to log in before showing the modal, but first we need to ensure
      // that modal does open when user is redirected back to this listingpage
      callSetInitialValues(setInitialValues, { enquiryModalOpenForListingId: params.id });

      // signup and return back to listingPage.
      history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}), state);
    } else {
      this.setState({ enquiryModalOpen: true });
    }
  }

  onSubmitEnquiry(values) {
    const { history, params, onSendEnquiry } = this.props;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const { message } = values;

    const currentListing = ensureListing(this.props.getListing(listingId));
    const bookingType =
      currentListing.attributes.publicData.bookingType === 'request'
        ? 'flex-default-process/release-1'
        : 'instant-booking/release-1';

    onSendEnquiry(listingId, message.trim(), bookingType)
      .then(txId => {
        this.setState({ enquiryModalOpen: false });

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  onSubmitSubscribe(selectedDate) {
    const { history, params, onSubscribe } = this.props;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const rawParams = this.props.params;
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(this.props.getListing(listingId));
    const currentUser = this.props.currentUser;
    this.setState({ loadingSpinner: true });
    onSubscribe(listingId, selectedDate, currentListing, currentUser)
      .then(txId => {
        //this.setState({ enquiryModalOpen: false });

        // Redirect to OrderDetailsPage
        return history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  onSubmitRequestSubscribe(selectedDate) {
    //requestSubscribe
    const { history, params, onRequestSubscribe } = this.props;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const rawParams = this.props.params;
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(this.props.getListing(listingId));
    const currentUser = this.props.currentUser;
    this.setState({ loadingSpinner: true });

    onRequestSubscribe(listingId, selectedDate, currentListing, currentUser)
      .then(txId => {
        //this.setState({ enquiryModalOpen: false });

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  render() {
    const {
      unitType,
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      intl,
      onManageDisableScrolling,
      params: rawParams,
      location,
      scrollingDisabled,
      showListingError,
      reviews,
      fetchReviewsError,
      sendEnquiryInProgress,
      sendEnquiryError,
      sendSubscribeInProgress,
      sendSubscribeError,
      sendRequestSubscribeInProgress,
      sendRequestSubscribeError,
      timeSlots,
      fetchTimeSlotsError,
      filterConfig,
      onFetchTransactionLineItems,
      lineItems,
      fetchLineItemsInProgress,
      fetchLineItemsError,
    } = this.props;

    const listingId = new UUID(rawParams.id);
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };

    const listingType = isDraftVariant
      ? LISTING_PAGE_PARAM_TYPE_DRAFT
      : LISTING_PAGE_PARAM_TYPE_EDIT;
    const listingTab = isDraftVariant ? 'photos' : 'description';
    const isApproved =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;
    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    const subscriptionObject = currentListing?.attributes?.publicData?.subscriptionObj;
    const isSubscriptionStillAvailable =
      subscriptionObject &&
      (subscriptionObject.status === 'active' || subscriptionObject.status === 'trialing');
    const isSubscriptionCancelled = subscriptionObject && subscriptionObject.status === 'canceled';
    const currentSubscriptionEnd =
      subscriptionObject && new Date(subscriptionObject.current_period_end * 1000);

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
      (isPendingApprovalVariant || isDraftVariant) &&
      showListingError &&
      showListingError.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

    if (shouldShowPublicListingPage) {
      return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const {
      description = '',
      geolocation = null,
      price = null,
      title = '',
      publicData,
    } = currentListing.attributes;

    const richTitle = (
      <span>
        {richText(title, {
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
          longWordClass: css.longWord,
        })}
      </span>
    );

    const bookingTitle = (
      <FormattedMessage id="ListingPage.bookingTitle" values={{ title: richTitle }} />
    );
    const bookingSubTitle = intl.formatMessage({ id: 'ListingPage.bookingSubTitle' });

    const topbar = <TopbarContainer />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <Page title={errorTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    } else if (!currentListing.id) {
      // Still loading the listing

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <Page title={loadingTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    }

    const handleViewPhotosClick = e => {
      // Stop event from bubbling up to prevent image click handler
      // trying to open the carousel as well.
      e.stopPropagation();
      this.setState({
        imageCarouselOpen: true,
      });
    };
    const authorAvailable = currentListing && currentListing.author;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const isOwnListing =
      userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;
    const showContactUser = authorAvailable && (!currentUser || (currentUser && !isOwnListing));

    const currentAuthor = authorAvailable ? currentListing.author : null;
    const ensuredAuthor = ensureUser(currentAuthor);

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

    const { formattedPrice, priceTitle } = priceData(price, intl);

    const handleBookingSubmit = values => {
      const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
      if (isOwnListing || isCurrentlyClosed) {
        window.scrollTo(0, 0);
      } else {
        this.handleSubmit(values);
      }
    };

    const listingImages = (listing, variantName) =>
      (listing.images || [])
        .map(image => {
          const variants = image.attributes.variants;
          const variant = variants ? variants[variantName] : null;

          // deprecated
          // for backwards combatility only
          const sizes = image.attributes.sizes;
          const size = sizes ? sizes.find(i => i.name === variantName) : null;

          return variant || size;
        })
        .filter(variant => variant != null);

    const facebookImages = listingImages(currentListing, 'facebook');
    const twitterImages = listingImages(currentListing, 'twitter');
    const schemaImages = JSON.stringify(facebookImages.map(img => img.url));
    const siteTitle = config.siteTitle;
    const schemaTitle = intl.formatMessage(
      { id: 'ListingPage.schemaTitle' },
      { title, price: formattedPrice, siteTitle }
    );

    const hostLink = (
      <NamedLink
        className={css.authorNameLink}
        name="ListingPage"
        params={params}
        to={{ hash: '#host' }}
      >
        {authorDisplayName}
      </NamedLink>
    );

    const vehiclesOptions = findOptionsForSelectFilter('vehicleCompatibility', filterConfig);
    const amenityOptions = findOptionsForSelectFilter('amenities', filterConfig);
    const categoryOptions = findOptionsForSelectFilter('category', filterConfig);
    const category =
      publicData && publicData.category ? (
        <span>
          {categoryLabel(categoryOptions, publicData.category)}
          <span className={css.separator}>•</span>
        </span>
      ) : null;

    // subscription related logic

    const hasSubscriptionPrice =
      currentListing && currentListing?.attributes.publicData?.subscriptionPrice;
    const hasCustomerId = currentUser?.attributes.profile.protectedData.stripeCustomerId;

    const subscriptionPrice =
      hasSubscriptionPrice && new Money(hasSubscriptionPrice, config.currency);
    const subscriptionPriceLabel = priceData(subscriptionPrice, intl)?.priceTitle;

    const isRequestBook =
      currentListing && currentListing.attributes.publicData?.bookingType === 'request';

    const onSubmitSubscribeFunction = selectedDate => {
      return this.onSubmitSubscribe(selectedDate);
    };
    const onRequestSubmitFunction = selectedDate => {
      return this.onSubmitRequestSubscribe(selectedDate);
    };
    const SubscriptionSection = () => {
      const [focused, setFocused] = useState(false);
      const [modalOpen, setModalOpen] = useState(false);
      const [noCustomerIdError, setNoCustomerIdError] = useState(false);
      const [loading, setLoading] = useState(false);
      const [selectedDate, setSelectedDate] = useState(moment(new Date()));

      useEffect(() => {
        if (timeSlots && timeSlots.length > 0) {
          if (subscriptionObject && !isSubscriptionStillAvailable && currentSubscriptionEnd) {
            setSelectedDate(moment(currentSubscriptionEnd.addDays(1)));
          }
        }
      }, [timeSlots]);

      const dayBlocked = day => {
        const today = new Date();
        const maximumAvailableDate = today.addDays(170);
        const calendarDate = new Date(day);
        const firstDate = new Date();
        const twoMonthAheadOfFirstDate = firstDate.addDays(60);

        if (
          calendarDate.getTime() > maximumAvailableDate.getTime() ||
          calendarDate.getTime() < firstDate.getTime() ||
          calendarDate.getTime() > twoMonthAheadOfFirstDate.getTime() ||
          (!isSubscriptionStillAvailable && currentSubscriptionEnd >= calendarDate)
        ) {
          return true;
        } else {
          return false;
        }
      };

      return hasSubscriptionPrice ? (
        <>
          <h2 className={css.descriptionTitle}>Abonnement</h2>
          <div className={css.subscriptionWrapper}>
            <div className={css.datePicker}>
              <p className={css.selectDateLabel}>
                Il est possible de louer ce parking en location mensuelle au tarif de{' '}
                <span className={css.subscriptionPrice}>{subscriptionPriceLabel} / mois</span>
              </p>
              <p className={css.selectDateLabel}>
                Vous êtes intéressé(e) par une location de plus de <strong>2 mois</strong>? Vous
                pouvez me contacter pour une visite :{' '}
                <a href="tel:+33 6 48 54 30 88">+33 6 48 54 30 88</a>
              </p>
              <p className={css.selectDateLabel}>
                Si la visite est concluante, vous pourrez débuter votre abonnement à la date
                souhaitée.
              </p>
              <div className={css.selectWrapper}>
                <SingleDatePicker
                  readOnly
                  focused={focused}
                  onFocusChange={values => setFocused(values.focused)}
                  date={selectedDate}
                  onDateChange={date => setSelectedDate(date)}
                  placeholder={'Début'}
                  numberOfMonths={1}
                  displayFormat="📅 DD MM YYYY"
                  phrases={{ closeDatePicker: 'close', clearDate: 'clear' }}
                  isDayBlocked={dayBlocked}
                />
              </div>
            </div>

            <div className={css.subcribeButton}>
              <Button
                className={css.button}
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                {isRequestBook ? 'Débuter l’abonnement' : 'Débuter l’abonnement'}
              </Button>
            </div>
            <Modal
              isOpen={modalOpen}
              onClose={() => {
                return setModalOpen(false);
              }}
              onManageDisableScrolling={() => {}}
            >
              <div className={css.subscriptionModalWrapper}>
                <center>
                  <h1>{richTitle}</h1>
                  <h2>
                    Date de début : <br /> {new Date(selectedDate)?.toLocaleDateString()}
                  </h2>
                </center>
                <div className={css.modalInfoSection}>
                  <h2 style={{ marginBottom: '0px' }}>✅ Sans engagement</h2>
                  <h2 style={{ marginTop: '0px' }}>✅ Résiliable à tout moment</h2>
                  <p className={css.line}></p>
                  <h2>
                    Votre première mensualité :<br />{' '}
                    <span className={css.subscriptionPrice}>{subscriptionPriceLabel}</span>
                  </h2>
                </div>

                <Button
                  type="button"
                  onClick={e => {
                    if (hasCustomerId) {
                      setLoading(true);
                      if (isRequestBook) {
                        return onRequestSubmitFunction(selectedDate);
                      } else {
                        return onSubmitSubscribeFunction(selectedDate);
                      }
                    } else {
                      return setNoCustomerIdError(true);
                    }
                  }}
                >
                  {loading
                    ? 'Chargement...'
                    : isRequestBook
                    ? 'Débuter mon abonnement'
                    : "S'aboner"}
                </Button>
                {noCustomerIdError ? (
                  <p>
                    Avant de pouvoir débuter votre abonnement, vous devez{' '}
                    <a href="/account/payment-methods">ajouter un mode de paiement</a>
                  </p>
                ) : null}
              </div>
            </Modal>
          </div>
        </>
      ) : null;
    };
    // end of subscription related logic
    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        author={authorDisplayName}
        contentType="website"
        description={description}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ItemPage',
          description: description,
          name: schemaTitle,
          image: schemaImages,
        }}
      >
        <LayoutSingleColumn className={css.pageRoot}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div>
              <SectionImages
                title={title}
                listing={currentListing}
                isOwnListing={isOwnListing}
                editParams={{
                  id: listingId.uuid,
                  slug: listingSlug,
                  type: listingType,
                  tab: listingTab,
                }}
                imageCarouselOpen={this.state.imageCarouselOpen}
                onImageCarouselClose={() => this.setState({ imageCarouselOpen: false })}
                handleViewPhotosClick={handleViewPhotosClick}
                onManageDisableScrolling={onManageDisableScrolling}
              />
              <div className={css.contentContainer}>
                <SectionAvatar user={currentAuthor} params={params} />
                <div className={css.mainContent}>
                  <SectionHeading
                    priceTitle={priceTitle}
                    formattedPrice={formattedPrice}
                    richTitle={richTitle}
                    category={category}
                    hostLink={hostLink}
                    showContactUser={showContactUser}
                    onContactUser={this.onContactUser}
                  />
                  <SectionDescriptionMaybe description={description} />
                  <SectionFeaturesMaybe
                    options={vehiclesOptions}
                    publicData={publicData}
                    practicalInfo={<SectionPracticalInfo publicData={publicData} />}
                    subscriptionSection={<SubscriptionSection />}
                    hideSubscription={isSubscriptionStillAvailable}
                  />
                  {/* <SectionRulesMaybe publicData={publicData} /> */}
                  <SectionMapMaybe
                    geolocation={geolocation}
                    publicData={publicData}
                    listingId={currentListing.id}
                  />
                  <SectionReviews reviews={reviews} fetchReviewsError={fetchReviewsError} />
                  <SectionHostMaybe
                    title={title}
                    listing={currentListing}
                    authorDisplayName={authorDisplayName}
                    onContactUser={this.onContactUser}
                    isEnquiryModalOpen={isAuthenticated && this.state.enquiryModalOpen}
                    onCloseEnquiryModal={() => this.setState({ enquiryModalOpen: false })}
                    sendEnquiryError={sendEnquiryError}
                    sendEnquiryInProgress={sendEnquiryInProgress}
                    sendSubscribeError={sendSubscribeError}
                    sendSubscribeInProgress={sendSubscribeInProgress}
                    sendRequestSubscribeError={sendRequestSubscribeError}
                    sendRequestSubscribeInProgress={sendRequestSubscribeInProgress}
                    onSubmitEnquiry={this.onSubmitEnquiry}
                    currentUser={currentUser}
                    onManageDisableScrolling={onManageDisableScrolling}
                  />
                </div>
                {isSubscriptionStillAvailable ? (
                  <center className={css.alreadySubscribedLabel}>
                    <p>Quelqu'un s'est déjà abonné à cette annonce</p>
                  </center>
                ) : (
                  <BookingPanel
                    className={css.bookingPanel}
                    listing={currentListing}
                    isOwnListing={isOwnListing}
                    unitType={unitType}
                    onSubmit={handleBookingSubmit}
                    title={bookingTitle}
                    subTitle={bookingSubTitle}
                    authorDisplayName={authorDisplayName}
                    onManageDisableScrolling={onManageDisableScrolling}
                    timeSlots={timeSlots}
                    fetchTimeSlotsError={fetchTimeSlotsError}
                    onFetchTransactionLineItems={onFetchTransactionLineItems}
                    lineItems={lineItems}
                    fetchLineItemsInProgress={fetchLineItemsInProgress}
                    fetchLineItemsError={fetchLineItemsError}
                    onSubmitSubscribe={this.onSubmitSubscribe}
                    onSubmitRequestSubscribe={this.onSubmitRequestSubscribe}
                    // setDate={this.setDate}
                    currentUser={currentUser}
                    isSubscriptionCancelled={
                      isSubscriptionCancelled ||
                      (subscriptionObject && !isSubscriptionStillAvailable)
                    }
                    currentSubscriptionEnd={currentSubscriptionEnd}
                  />
                )}
              </div>
              {this.state.loadingSpinner && (
                <div className={css.loadingScreen}>
                  <CircularProgress size={120} style={{ color: '#85add9' }} />
                </div>
              )}
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

ListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  enquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  sendEnquiryError: null,
  sendSubscribeError: null,
  sendRequestSubscribeError: null,
  filterConfig: config.custom.filters,
  lineItems: null,
  fetchLineItemsError: null,
};

ListingPageComponent.propTypes = {
  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  unitType: propTypes.bookingUnitType,
  // from injectIntl
  intl: intlShape.isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  enquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  sendEnquiryInProgress: bool.isRequired,
  sendEnquiryError: propTypes.error,
  onSendEnquiry: func.isRequired,
  sendSubscribeInProgress: bool.isRequired,
  sendSubscribeError: propTypes.error,
  onSubscribe: func.isRequired,
  sendRequestSubscribeInProgress: bool.isRequired,
  sendRequestSubscribeError: propTypes.error,
  onRequestSubscribe: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  filterConfig: array,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    sendSubscribeInProgress,
    sendSubscribeError,
    sendRequestSubscribeInProgress,
    sendRequestSubscribeError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    enquiryModalOpenForListingId,
  } = state.ListingPage;
  const { currentUser } = state.user;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    sendSubscribeInProgress,
    sendSubscribeError,
    sendRequestSubscribeInProgress,
    sendRequestSubscribeError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: (bookingData, listingId, isOwnListing) =>
    dispatch(fetchTransactionLineItems(bookingData, listingId, isOwnListing)),
  onSendEnquiry: (listingId, message, bookingType) =>
    dispatch(sendEnquiry(listingId, message, bookingType)),
  onSubscribe: (listingId, selectedDate, currentListing, currentUser) =>
    dispatch(subscribe(listingId, selectedDate, currentListing, currentUser)),
  onRequestSubscribe: (listingId, selectedDate, currentListing, currentUser) =>
    dispatch(requestSubscribe(listingId, selectedDate, currentListing, currentUser)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ListingPageComponent);

export default ListingPage;
